<template>
  <ExamAnalysis @goRepeat="goRepeat" reportType="random">
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <span>随机练习</span>
        <span class="slash">/</span>
        <span class="current">题目解析</span>
      </div>
    </template>
  </ExamAnalysis>
</template>
<script>
import ExamAnalysis from "./components/ExamAnalysis";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamRandomAnalysis",
  components: {
    ExamAnalysis,
    ExamIndexBread,
  },
  methods: {
    async goRepeat() {
      let data = await this.$http.post("/api/app/practice/report", {
        type: 5,
        report_id: this.$route.query.id,
      });
      if (data.length === 0) {
        this.$info("当前没有题目可以练习");
        return;
      }
      this.$router.push({
        name: "ExamRandomDo",
        query: {
          id: data,
        },
      });
    },
  },
};
</script>
